<template>
    <div>
        <div class="container-fluid">
            <div class="row content-body justify-content-center">
                <div class="col">
                    <div class="container">

                        <div class="text-center mb-5">
                            <div class=" ">
                                <div class="main-title txt-primary">Retirement Checkup</div>
                                <div class="md-headline txt-gray">วางแผน คำนวณเป้าหมายเงินเก็บหลังเกษียณ</div>
                            </div>
                        </div>


                        <md-card>
                            <md-card-header class="background-primary">
                                <div>
                                    <div class="md-title"> Advanced Mode</div>
                                </div>
                            </md-card-header>

                            <md-card-content class="stepper">

                                <div class="stepper-content" v-if="advance.mainStepActive === 1">
                                    <advance-form></advance-form>
                                </div>


                                <div class="stepper-content" v-if="advance.mainStepActive === 2">
                                    <result-advance></result-advance>
                                </div>


                            </md-card-content>
                        </md-card>


                    </div>
                </div>
            </div>
        </div>


    </div>
</template>


<script>
  import ResultAdvance from "../components/resultAdvance";
  import AdvanceForm from "../components/advanceForm";
  import {mapState} from 'vuex';

  import store from '../store';
  import {GET_ADVANCE_RESULT_RETIREMENT_PLAN, SET_ADVANCE_STEPPER_DATA} from '../store/actions.type'

  export default {
    name: 'Advance',
    components: {AdvanceForm, ResultAdvance},
    computed: mapState({
      advance: state => state.advance
    }),
    created() {

      let params = this.$route.query;
      let obj = {};


      if (params.uid) {
        store.dispatch(GET_ADVANCE_RESULT_RETIREMENT_PLAN, params.uid);
      }


      if (params.employee) {
        obj.employee = params.employee;
      }

      if (params.employee) {
        obj.employer = params.employer;
      }

      if (params.employee) {
        obj.planPVD = params.pvd_plan;
      }

      if (params.employee) {
        obj.pvdRate1 = params.pvd_eq_value;
      }

      store.dispatch(SET_ADVANCE_STEPPER_DATA, {key: 'form', data: obj});

    }
  }
</script>


<style scoped lang="scss">
    @import "../assets/css/colors";

    .content-body {
        background-image: url("../assets/images/bg.png");
        background-color: $smoke;
        background-attachment: fixed;
    }

    .md-card {
        border-radius: 8px;
    }

    .md-card-header {
        border-radius: 8px 8px 0 0;
    }


    .guidePlan {
        padding: 15px;
        background-color: $smoke;
        border-radius: 8px;
        margin-bottom: 30px;
        border: 2px solid $navy;
    }

    .title {
        font-size: 22px;
        margin-bottom: 15px;
        line-height: 1.1;
        text-align: center;
    }

    .button-gray {
        margin-bottom: 15px;
    }

    .line {
        max-width: 100px;
        background-color: $navy;
    }

    .content {
        height: 200px;
    }

    .stepper-content, .result {
        font-size: 22px;
    }

    .img-flag {
        max-height: 150px;
    }


    .main-title {
        font-size: 55px;
        line-height: 1.2;
    }

    @media only screen and (min-width: 768px) {
        .stepper-content {
            padding-right: 80px;
            padding-left: 80px;
        }
    }

    @media only screen and (max-width: 578px) {

        .main-title {
            font-size: 45px;
        }

        .img-flag {
            max-height: 80px;
        }
    }
</style>
